import { render, staticRenderFns } from "./WarehouseTransferAttention.vue?vue&type=template&id=b7513cf6"
import script from "./WarehouseTransferAttention.vue?vue&type=script&lang=js"
export * from "./WarehouseTransferAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports